module.exports = __webpack_public_path__ + "img/GG.417e552d.svg";